module.exports = __webpack_public_path__ + "media/images/article/2021_12-62dc1916f684a799b61b3a7b82cad303.png";